import React from "react";
import { injectIntl } from 'react-intl';
import { Select } from "antd";
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';

import { history } from "../../store/_store";

import "./AuthContainer.scss";

import SignInForm from "../AuthScreens/Signin";
import SignUpForm from "../AuthScreens/Signup";
import ResetForm from "../AuthScreens/Reset";
import AuthAside from "../AuthScreens/Aside";
import Invitation from "../AuthScreens/Invitation";
import Verification from "../AuthScreens/Verification";
import CreateAccount from '../AuthScreens/CreateAccount';
import ChooseAccount from '../AuthScreens/ChooseAccount';

const AuthContainer = (props) => {
  const { _utils, setLang } = props;

  return (
    <Router>
      <ConnectedRouter history={history}>
        <div className="authWrapper">
          <div className="authWrapper__Body">
            <div className="authWrapper__FormCard">
              <AuthAside {...props} />
              <div className="authWrapper__FormCardRight">
                <div className="formContainer">

                  <Switch>
                    {/* ::: auth */}
                    <Route exact path="/:lang/signin" render={() => <SignInForm {...props} />} />
                    <Route exact path="/:lang/signup" render={() => <SignUpForm {...props} />} />
                    <Route exact path="/:lang/reset" render={() => <ResetForm {...props} />} />
                    <Route exact path="/:lang/reset/:token" render={(routeProps) => <ResetForm {...routeProps} {...props} />} />
                    <Route exact path="/:lang/create-account" render={() => <CreateAccount {...props} />} />
                    <Route exact path="/:lang/choose-account" render={() => <ChooseAccount {...props} />} />
                    <Route exact path="/:lang/invitation/:token" render={(routeProps) => <Invitation {...routeProps} {...props} />} />
                    <Route exact path="/:lang/verification/:token" render={(routeProps) => <Verification {...routeProps} {...props} />} />

                    <Redirect to={`/${_utils.lang}/signin`} />
                  </Switch>

                </div>
                <div style={{ textAlign: 'center', marginTop: '10%', fontSize: 13, width: '40%', marginLeft: '13%' }}>
                  <Select className="switch__lang" defaultValue={_utils.lang} size="small" sso-id="language-switcher" style={{ color: '#eee' }} onChange={(lang) => { setLang(lang); }}>
                    <Select.Option value="en">English</Select.Option>
                    <Select.Option value="fr">Français</Select.Option>
                  </Select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ConnectedRouter>
    </Router>
  );
};

export default injectIntl(AuthContainer);